import { parsePhoneNumber } from 'awesome-phonenumber'
import { computed, type ComputedRef } from 'vue'
import GatPhoneEditFunctions from '../functions/GatPhoneEditFunctions'
import {
  type GatPhoneEditModelValue,
  type GatPhoneEditProps
} from '../gat-phone-edit.vue'
import type { FormFieldValidationRule } from '../../gat-form-field/useFormField'

export function useGatPhoneEditValidation(
  props: GatPhoneEditProps,
  defaultRules: GatPhoneEditProps['rules'],
  countryDialNumber: ComputedRef<string | undefined>,
  countryCode: ComputedRef<string | undefined>
) {
  const isMobile = computed(() => {
    const value = props.modelValue
    if (!value) {
      return false
    }
    const validator = parsePhoneNumber(value)
    return validator.typeIsMobile
  })

  const phoneEditRules = computed((): GatPhoneEditProps['rules'] => {
    const result: FormFieldValidationRule<GatPhoneEditModelValue>[] = []

    if (Array.isArray(defaultRules)) {
      defaultRules.forEach((rule) => result.push(rule))
    } else if (defaultRules) {
      result.push(defaultRules)
    }

    // valid phone number
    result.push((value: GatPhoneEditModelValue) => {
      // ok med blankt nummer, eller dersom bare landskoden står igjen (blir fjernet senere)
      const countryDial = countryDialNumber.value
      if (value && value !== countryDial) {
        let validator = parsePhoneNumber(value)
        if (value?.startsWith('+')) {
          validator = parsePhoneNumber(String(value), {
            regionCode: countryCode.value
          })
        }
        if (!validator.valid) {
          return `Invalid phone number: '${value}'`
        }
      }
      return true
    })

    // required
    result.push((value: GatPhoneEditModelValue) => {
      if (GatPhoneEditFunctions.emptyNumber(value) && props.required) {
        return 'required'
      }
      return true
    })

    // mobile only
    if (props.mobileOnly) {
      result.push(() => {
        if (isMobile.value) {
          return true
        }
        return 'Not a valid mobile number'
      })
    }

    return result
  })

  return {
    phoneEditRules
  }
}
